/*eslint-disable */

import Push from 'push.js';
import appointmentStatusPopup from "../appointment-status-change-popup/index.vue";
import audioPlay from '@/assets/audio/piano.mp3';
import {bus} from '@/main';
import chatWithPatient from "../chat-of-patient/index.vue";
import countries from '@/services/country.json';
import {
  mapGetters,
} from 'vuex';
import notesOfPatient from "../notes-of-patient/index.vue";
import prescriptionsOfPatient from "../pre-of-patient/index.vue";
import remarksOfPatient from "../remarks/index.vue";
import videoRecording from '@/components/private/consult/video-recording-data/';
import videoSocketRef from "@/videoNotificationSocket";

const $ = window.jQuery = require('jquery');
export default {
  name: 'consult-dashboard',
  components: {
    'notes-of-patient': notesOfPatient,
    'prescriptions-of-patient' : prescriptionsOfPatient,
    'notes-of-remarks' : remarksOfPatient,
    'chat-with-patient' : chatWithPatient,
    'appointment_status-popup' : appointmentStatusPopup,
    'video-record' : videoRecording
  },
  props: ['consultID'],
  data () {
    return {
      consultPatientList:{},
      consultPatientListResults:[],
      activeConsultPatient:'',
      consultPatientInfo:{},
      patientDetailsLoader:false,
      consultWorkspaceTabs:'notes',
      consultPatientDShowState:true,
      chatWithPatientId:'',
      countryList:[],
      appointmentStatusPopup:false,
      appointmentStatusForData:{},
      videRecordState:false,
      RecordForDoctorId:'',
      callTextState:false,
      selectedPatientId:'',
      appointmentStatusForFlag:'',
      selfUserInfo:null,
    }
  },
  computed: {
    ...mapGetters([
      'getconsultPatientGetters',
      'getconsultPatientByIdGetters',
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoFun() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getConsultPatientListFun(){
      this.consultPatientList = this.$store.getters.getconsultPatientGetters.data;
      return
    },
    setIntialStateOfConsultPatient(){
      if(this.consultPatientList != undefined){
        this.consultPatientListResults = this.consultPatientList.data
      }
      return
    },
    getConsultPatientDetailByIdFun(){
      this.consultPatientInfo = this.$store.getters.getconsultPatientByIdGetters.data;
      return
    },
  },
  mounted () {
    this.getConsultPatientListFun
    this.setIntialStateOfConsultPatient
    this.getConsultPatientDetailByIdFun
    this.getSelfUserInfoFun
    this.activeConsultPatient = this.$route.params.consultID
    bus.$on('chatInitWithPatientBus', (data) => {
      this.consultPatientDShowState = data
    });
    bus.$on('appointmentStatusPopupBus', (data) => {
      this.appointmentStatusPopup = data
    });
    bus.$on('consultPatientInfoBus', (data) => {
      this.consultPatientInfo = data
    });
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    bus.$on('videRecordStateBus', (data) => {
      this.videRecordState = data
    });
    bus.$on('userUpdateStatus', (data) => {
      let user = this.consultPatientListResults.find(item => {
       return item.user.id == data.userID;
      });
      if(user) {
        user.is_online = data.is_online;
      }
    });
    bus.$on('userUpdateStatus', (data) => {
      if(this.consultPatientInfo.user.id == data.userID) {
        this.consultPatientInfo.is_online = data.is_online;
      }
    });
    bus.$on('updateMessageNotification', (data) => {
      if(data.totalUnreadCount > 0){
        if(Push.Permission.has()){
          Push.create(data.msgSenderFullName, {
            body:data.senderMsgData,
            timeout:4000,
            onClick: function () {
                window.focus();
                this.close();
            }
          })
        }else{
          this.playSound(audioPlay)
        }
        if (this.consultPatientInfo.user.id == data.fromUserID){
          this.consultPatientInfo.unread_count = data.unreadCount
        }
    }
    })
  },
  methods: {
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    /*
    * This Will Video Call Request Function
    */
    videoCallRequestFun(patientInfo) {
      let callerId = patientInfo.user.id
      this.callTextState = true;
      let callerFullName = this.selfUserInfo.salutation + ' ' + this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
      videoSocketRef.emit({
        message: `${callerFullName} is calling you.`,
        type: "videoCalling",
        displayName: callerFullName,
        callerID: this.selfUserInfo.id,
        targetId: callerId,
        second_user_id: callerId,
        'chat_data': {
          'message': 'Missed Call'
        }
      });
      videoSocketRef.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      videoSocketRef.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      videoSocketRef.$on('videoCallAlertPopupClosed', this.notrecievedCall);
      videoSocketRef.$on('autoMissedCallEvent', this.autoMissedCall);
    },
    getAnswerOfVideoCall(getAnswerData) {
      if (this.selfUserInfo.id == getAnswerData.returnCallerUserId) {
        this.$router.push('/video/call/one-to-one-peer/#' + getAnswerData.videoCallRoomId)
      }
    },
    getDeclinedOfVideoCall(declinedData) {
      this.callTextState = false
    },
    notrecievedCall(notrecievedData) {
      this.callTextState = false
    },
    autoMissedCall(mCallData) {
      this.callTextState = false
    },
    consultPatientTabMethod(ID){
      if(this.activeConsultPatient === ID) return;
      this.activeConsultPatient = ID
      this.$router.push({ name: 'patientConsultDetails', params: { consultID: ID } })
    },
    consultInfoTabsMethod(tab){
      this.consultInfoTabs = tab
    },
    backArrow(){
      return this.$router.go(-1)
    },
    consultWorkspaceTabsActvmethod(status){
      this.consultWorkspaceTabs = status
      this.activeConsultPatient = this.activeConsultPatient
    },
    consultPatientDShowStateMethod(userInfo){
      this.chatWithPatientId = userInfo
      this.consultPatientDShowState = false
      this.consultPatientInfo.unread_count = 0
    },
    appointmentStatusUpdatedFun(data, flag){
      this.appointmentStatusPopup = true
      this.appointmentStatusForData = data
      this.appointmentStatusForFlag = flag
    },
    getCountryName(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
    videoRecordingPopupOpen(Id){
      this.RecordForDoctorId = Id
      this.videRecordState = true
    }
  },
  watch: {
    getConsultPatientListFun(){
      return this.$store.getters.getconsultPatientGetters
    },
    setIntialStateOfConsultPatient(){
      if(this.consultPatientList != undefined){
        this.consultPatientListResults = this.consultPatientList.data
      }
      return
    },
    getConsultPatientDetailByIdFun(){
      return this.$store.getters.getconsultPatientByIdGetters;
    },
    consultID(new_val, old_val){
      this.patientDetailsLoader = true
      this.activeConsultPatient = new_val
      this.consultWorkspaceTabs = 'notes'
      this.consultPatientDShowState = true
      this.$store.dispatch('getconsultPatientDetailyIdMethod', { id: new_val }).then((res) => {
        this.patientDetailsLoader = false
      }).catch((err) => {
      })
    },
    getSelfUserInfoFun() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
  },
  beforeRouteLeave: function (to, from, next) {
    next();
  },
}